import { render, staticRenderFns } from "./BindResource.vue?vue&type=template&id=890acaae&"
import script from "./BindResource.vue?vue&type=script&lang=js&"
export * from "./BindResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports